import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import OrderLayout from '../../components/orders/orders-layout';

function OrdersAllContainer(): React.ReactElement {
  return <OrderLayout orderStatusTypeCodes={Object.values(EOrderStatus)} />;
}

export default OrdersAllContainer;
